import { Box, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { Alert, UpliftThemeProvider } from '@uplift/ui-v2';
import React from 'react';


export const PurpleAlert = withStyles(Alert, theme => ({
  root: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.secondary.border,
    background: theme.palette.secondary.background,
    textAlign: 'center',
  },
  title: {
    fontWeight: 700,
  },
}));


export const LoginHeader: React.VFC<{ isAutoSignOut: boolean }> = ({ isAutoSignOut }) => {
  const l10n = useL10n();

  if (isAutoSignOut) {
    return (
      <UpliftThemeProvider>
        <Box maxWidth="604px" mb={5}>
          <PurpleAlert title={l10n.auth.errors.youWereSignedOut.title} showIcon={false}>
            {l10n.auth.errors.youWereSignedOut.details}
          </PurpleAlert>
        </Box>
        <Typography sx={{ mb: 4 }} variant="h2" align="center">{l10n.auth.signBackIn}</Typography>
      </UpliftThemeProvider>
    );
  }

  return (
    <>
      <Box mt={13} />
      <Typography sx={{ mb: 4 }} variant="h2" align="center">{l10n.auth.signIn}</Typography>
    </>
  );
};
